export * from './baseRes'
export * from './base.interface'